import { ACCEPTED_PREVIEW_TYPES } from '../../constants';
import { Preview, SelectedPreviewState } from './types';

export const filterPreviews = (previews: Preview[]) =>
  previews.filter((preview) => {
    return ACCEPTED_PREVIEW_TYPES.includes(preview.previewTypeId);
  });

export const getInitialPreview = (previews: Preview[]): SelectedPreviewState =>
  previews.find((preview) => preview.previewTypeId === 'primary') ||
  previews[0];
